export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', native_name: 'English', is_enabled: true, is_default: true, flag: '🇬🇧' },
  { code: 'cs', name: 'Czech', native_name: 'Čeština', is_enabled: true, is_default: false, flag: '🇨🇿' },
  { code: 'ru', name: 'Russian', native_name: 'Русский', is_enabled: true, is_default: false, flag: '🇷🇺' },
  // Add more as needed
];